// removed by extract-text-webpack-plugin
module.exports = {"accordion":"_17p9qlER7Uv-HYMHMrOQLt","active":"_3-tCMGm-A6g6CTUq-vzcgv","end":"_3oaRvVOCXmvoTftjxZ6pwg"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/atoms/BoxAccordion/style.css
// module id = 457
// module chunks = 37